import {InteractiveChatData} from 'types';

export type LiveHelpAutoReplyFields = {
    agentsAvailable: LiveHelpMessagesFields,
    agentsUnavailable: LiveHelpMessagesFields
}

export type FormFields = {
    welcome: LiveHelpMessagesFields,
    avatarWelcome: LiveHelpMessagesFields,
    deescalate: LiveHelpMessagesFields,
    autoReply: LiveHelpAutoReplyFields
}

export enum SectionName {
    Welcome = 'welcome',
    AvatarWelcome = 'avatarWelcome',
    Deescalate = 'deescalate',
    AutoReply = 'autoReply'
}

export enum AutoReplySections {
    AgentsAvailable = 'agentsAvailable',
    AgentsUnavailable = 'agentsUnavailable'
}

export enum MessageType {
    Text = 'text',
    InteractiveChat = 'interactive-chat'
}

export type MessageItem = {
    text?: string;
    type: MessageType;
    data?: InteractiveChatData;
}

export type LiveHelpMessagesFields = {
    messages: MessageItem[];
}